export const journalismConst = {
  path: "/single-programs/journalism",
  title: "ФАКУЛЬТЕТ КОММУНИКАЦИЙ И СОЦИАЛЬНЫХ НАУК – ЖУРНАЛИСТИКА",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Журналистика — точность, честность и голос современности</h2>
      <p>
        Программа готовит профессионалов в области медиа: печатной, телевизионной и цифровой журналистики. Студенты осваивают искусство
        создания текстов, репортажей, интервью, сценариев и видеоконтента, а также учатся проверять факты, понимать информационные потоки и
        работать этично в условиях цифровой эпохи.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Основы журналистики и медиа права</li>
        <li>Новостная подача, аналитика, интервьюирование</li>
        <li>Создание текстов для прессы, ТВ и онлайн-платформ</li>
        <li>Фактчекинг и медиаэтика</li>
        <li>Видеожурналистика и работа с мобильной студией</li>
        <li>Цифровая журналистика и мультимедийный контент</li>
        <li>Редакторская работа и медиа продюсирование</li>
        <li>Социальные сети и продвижение контента</li>
      </ul>
      <p>
        Программа сочетает теорию и интенсивную практику: реальные задания, съёмки, участие в медиа проектах, сотрудничество с редакциями и
        платформами.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Журналист в печатных и онлайн-СМИ</li>
        <li>Редактор или колумнист</li>
        <li>Медиа Продюсер и создатель контента</li>
        <li>Корреспондент, ведущий новостей</li>
        <li>SMM-специалист в СМИ и бизнесе</li>
        <li>Специалист по коммуникациям в НКО, госструктурах, международных организациях</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€40,000 до €80,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с высокой репутацией в сфере медиа</li>
        <li>Обучение на русском или английском языке</li>
        <li>Гибкая форма — очно или дистанционно</li>
        <li>Практика в медиакомпаниях и на телеканалах</li>
        <li>Современные студии, техника и мультимедийное ПО</li>
        <li>Поддержка приемной комиссии и наставничество в процессе учёбы</li>
      </ul>
      <p>Журналистика — это ответственность перед обществом. Мы учим работать с фактами, а не шумом.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам выбрать направление, собрать документы и пройти процесс поступления шаг за шагом.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Журналистика — точность, честность и голос современности
    Программа готовит профессионалов в области медиа: печатной, телевизионной и цифровой журналистики. Студенты осваивают искусство создания текстов, репортажей, интервью, сценариев и видеоконтента, а также учатся проверять факты, понимать информационные потоки и работать этично в условиях цифровой эпохи.
    Что вы будете изучать?
    • Основы журналистики и медиа права
    • Новостная подача, аналитика, интервьюирование
    • Создание текстов для прессы, ТВ и онлайн-платформ
    • Фактчекинг и медиаэтика
    • Видеожурналистика и работа с мобильной студией
    • Цифровая журналистика и мультимедийный контент
    • Редакторская работа и медиа продюсирование
    • Социальные сети и продвижение контента
    Программа сочетает теорию и интенсивную практику: реальные задания, съёмки, участие в медиа проектах, сотрудничество с редакциями и платформами.
    Кем можно работать после окончания?
    • Журналист в печатных и онлайн-СМИ
    • Редактор или колумнист
    • Медиа Продюсер и создатель контента
    • Корреспондент, ведущий новостей
    • SMM-специалист в СМИ и бизнесе
    • Специалист по коммуникациям в НКО, госструктурах, международных организациях
    Зарплата в Европе: от €40,000 до €80,000 в год
    Почему выбирают нас?
    • Европейский диплом с высокой репутацией в сфере медиа
    • Обучение на русском или английском языке
    • Гибкая форма — очно или дистанционно
    • Практика в медиакомпаниях и на телеканалах
    • Современные студии, техника и мультимедийное ПО
    • Поддержка приемной комиссии и наставничество в процессе учёбы
    Журналистика — это ответственность перед обществом. Мы учим работать с фактами, а не шумом.

    Как поступить?
    Приёмная комиссия поможет вам выбрать направление, собрать документы и пройти процесс поступления шаг за шагом.
  `,
};
